import { render, staticRenderFns } from "./EditCar.vue?vue&type=template&id=2afa1836&scoped=true&"
import script from "./EditCar.vue?vue&type=script&lang=js&"
export * from "./EditCar.vue?vue&type=script&lang=js&"
import style0 from "./EditCar.vue?vue&type=style&index=0&id=2afa1836&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afa1836",
  null
  
)

export default component.exports